import { renderToStaticMarkup } from 'react-dom/server';

type GetMarkerOptions = {
  fill?: string;
  stroke?: string;
  width?: number;
  heigth?: number;
};

const OccurrenceMarker = ({
  fill,
  stroke,
  width,
  heigth,
}: GetMarkerOptions) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 384 512"
    width={width}
    height={heigth}
  >
    <path
      d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
      fill={fill}
      stroke={stroke}
      strokeWidth={18}
    />
  </svg>
);

const getMarker = (options: GetMarkerOptions) => {
  const markerSvgString = encodeURIComponent(
    renderToStaticMarkup(<OccurrenceMarker {...options} />),
  );

  return `data:image/svg+xml,${markerSvgString}`;
};

export default getMarker;
